import {
  ACCOUNT_HAS_NO_ACCESS_SEARCH_PARAM,
  ACCOUNT_HAS_NO_ACCESS_SESSION_KEY,
  SESSION_KEY_RECENT_TENANT,
} from "../auth-constants";

export function CognitoCallbackLogoutPage() {
  // Only redirect to the right logout page.

  // We use SESSION_KEY_RECENT_TENANT here -- should probably use retrieveTenantAndOrganisation
  // as we have two methods now. But that one is reset before logout so can't be used atm.
  const recentTenant = window.sessionStorage.getItem(SESSION_KEY_RECENT_TENANT);

  // Don't use navigate as this may be in a different React app than the destination page.
  if (recentTenant) {
    // If the user account has been deactivated add that to the query params so the logged out page can show a message about that.
    const hasNoAccess = window.sessionStorage.getItem(ACCOUNT_HAS_NO_ACCESS_SESSION_KEY);
    const queryParams = hasNoAccess ? `?${ACCOUNT_HAS_NO_ACCESS_SEARCH_PARAM}=true` : "";

    // Needs setTimeout otherwise it gets deleted before the redirect on double renders.
    setTimeout(() => {
      window.sessionStorage.removeItem(ACCOUNT_HAS_NO_ACCESS_SESSION_KEY);
    });
    window.location.assign(`/${recentTenant}/logged-out${queryParams}`);
  } else {
    window.location.assign("/");
  }

  return null;
}
